/*
 * @@Description: 所有props
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 * @LastEditTime: 2021-10-20 14:29:19
 */
const BASE_DEFAULT_TYPE = {
  ARRAY: {
    type: Array,
    default: () => []
  },
  OBJECT: {
    type: Object,
    default: () => ({})
  },
  BOOLEAN: value => ({
    type: Boolean,
    default: !!value
  }),
  STRING: (value = '') => ({
    type: String,
    default: value
  })
}

// 内部默认 props 属性
export const TableProps = {
  forceExpand: {
    type: [Boolean, Function],
    default: false
  },
  defaultExpandAll: {
    type: [Boolean, Function],
    default: false
  },
  sticky: {
    type: [Boolean, Object],
    default: false
  },
  rowKey: BASE_DEFAULT_TYPE.STRING('key'), // 行key
  rowIndex: {
    type: Object,
    default: null
  }, // 是否显示index
  rowSelection: {
    type: Object,
    default: null
  }, // 筛选
   // 是否groupTable 分组的唯一key 相同的则在一组
  groupRowKey: {
    type: String
  },
  groupTitleRender: {
    default: null
  }, // groupTitleRender 渲染
  // groupTitleHeight: {}, // 如果当前时group-table需要传递一个title的高度并且内容区域不能超出该高度
  loading: BASE_DEFAULT_TYPE.BOOLEAN(), // loading不包括表头
  border: BASE_DEFAULT_TYPE.BOOLEAN(), // 边框
  columns: BASE_DEFAULT_TYPE.ARRAY, // 表头信息
  dataSource: BASE_DEFAULT_TYPE.ARRAY,
  height: [String, Number],
  maxHeight: [String, Number],
  // showHeader: BASE_DEFAULT_TYPE.BOOLEAN(true), // 是否显示表头
  // rowClassName: [String, Function], // 行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className
  // rowStyle: [Object, Function], // 行样式
  // cellClassName: [String, Function], // 单元格类名
  // cellStyle: [Object, Function], // 单元格样式
  headerRowClassName: [String, Function], // 表头类名
  // headerRowStyle: [Object, Function], // 表头样式
  // headerCellClassName: [String, Function], // 表头单元类名
  // headerCellStyle: [Object, Function], // 表头单元样式
  pagination: { type: Object, default: null } // 分页配置
}

// 表头信息
export const columnProps = {
  selectable: {
    type: Function,
    default: null
  }, // 是否可以勾选
  selectType: {
    type: String,
    default: 'checkbox' //checkbox/radio
  },
  type: {
    type: String,
    default: ''
  }, // 当前类型 selection, index , ''
  title: {
    type: String
  }, // 文本
  fixed: {
    type: [Boolean, String],
    default: false
  }, // 定位 left / right
  width: {
    type: [Number, String],
    default: 'auto'
  }, // 宽度  为String时单位为px
  minWidth: {
    type: [Number, String],
    default: 'auto'
  },
  align: {
    type: String,
    default: 'left'
  }, // 对齐方式

  renderIndex: {
    type: Function,
    default: null
  }, // 渲染
  reserveSelection: {
    type: Boolean,
    default: false
  }, // 配合row-key一起使用, 缓存勾选
  dataIndex: '',
  key: '',
  slots: '', // 表头插槽
  scopedSlots: '', // 内容插槽
  showOverflowTooltip: {
    default: false
  }, // 超出隐藏
  filters: {
    type: Array,
    default: null
  }, // 筛选
  filterMultiple: {
    type: Boolean,
    default: false
  }, // 筛选是否多选
  filterMethod: {
    type: [Function, Object],
    default: null
  },
  colSpan: '', // 合并表头
  customCell: '', // 单元格样式
  className: '', // className
  customHeaderCell: '' // 表头样式
}

// 单选多选配置
export const selectConfig = {}

// 固定插槽
// empty data为空

export const baseTableProps = {
  hasBody: BASE_DEFAULT_TYPE.BOOLEAN(),
  hasHead: BASE_DEFAULT_TYPE.BOOLEAN(true)
}
